import React, { useState, useEffect } from "react";
import { Card } from "antd";
import { CarOutlined, CalendarOutlined, ScheduleOutlined, FieldTimeOutlined } from "@ant-design/icons";
import { countStatsDashboard } from "../app/api";

const Counter = ({ end, duration }) => {
  const [count, setCount] = useState(0);

  useEffect(() => {
    let start = 0;
    const increment = Math.ceil(end / (duration * 60));
    const interval = setInterval(() => {
      start += increment;
      if (start >= end) {
        setCount(end);
        clearInterval(interval);
      } else {
        setCount(start);
      }
    }, 1000 / 60);

    return () => clearInterval(interval);
  }, [end, duration]);

  return <span style={{ fontSize: "24px", fontWeight: "bold", color: "#ff4d4f" }}>{count}</span>;
};

const StatsCard = ({ icon, count, label }) => (
  <Card bordered={false} style={{ width: 250, textAlign: "center", boxShadow: "0 4px 10px rgba(0,0,0,0.1)" }}>
    <div style={{ fontSize: "32px", color: "#ff4d4f", marginBottom: "10px" }}>{icon}</div>
    <Counter end={count} duration={2.5} />
    <p style={{ fontSize: "16px", fontWeight: "500", marginTop: "8px" }}>{label}</p>
  </Card>
);

const DashboardCarChart = () => {
    const [data, setData] = useState(null);
    
    const stats = [
        { icon: <CarOutlined />, count: data?.totalCarsCount || 0, label: "Ընդհանուր մեքենաների քանակ" },
        { icon: <CalendarOutlined />, count: data?.weeklyCarsCount || 0, label: "Շաբաթական մեքենաների քանակ" },
        { icon: <ScheduleOutlined />, count: data?.monthlyCarsCount || 0, label: "Ամսական մեքենաների քանակ" },
        { icon: <FieldTimeOutlined />, count: data?.yearlyCarsCount || 0, label: "Տարվա մեքենաների քանակ" },
    ];

    useEffect(() => {
        const fetchCountData = async () => {
          try {
            const response = await countStatsDashboard();
            const incomeData = response.data;
            setData(incomeData);
          } catch (error) {
            console.error('Error fetching income data:', error);
          }
        };
    
        fetchCountData();
    }, []);

    return (
        <div style={{ display: "flex", justifyContent: "center", gap: "20px", padding: "40px" }}>
        {stats.map((stat, index) => (
            <StatsCard key={index} {...stat} />
        ))}
        </div>
    );
};

export default DashboardCarChart;
